import React, { useState } from "react"

import { categoryClasses, categoryAccentVar } from "../utils/category-classes"
import { withStyles } from "@material-ui/core/styles"
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel"
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary"
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails"
import CtaCategories from "../components/Sections/CtaCategories"
import DividerHr from "../components/Elements/DividerHr"


const ExpansionPanel = withStyles({
    root: {
        paddingLeft: 0,
        paddingRight: 0,
        boxShadow: "none",
        margin: "auto",
        "&$expanded": {
            margin: "auto",
        },
        "@media screen and (min-width: 760px)": {
            borderRadius: "15px !important",
            "&$expanded": {
                background: `var(--gray-lightest)`,
            },
        },
    },
    expanded: {
        margin: "auto",
    },
})(MuiExpansionPanel)

const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: `28px`,
        paddingBottom: `40px`,
        borderTop: `1px solid var(--gray)`,
        "@media screen and (min-width: 760px)": {
            margin: `0 var(--space-xl)`,
        },
    },
}))(MuiExpansionPanelDetails)

const ExpandMoreIcon = () => (
    <svg
        width="20"
        height="12"
        viewBox="0 0 12 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11 1L6 6L1 1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default ({ data, categoryName, categorySlug }) => {
    const [panelActive, setPanelActive] = useState("")
    const ExpansionPanelSummary = withStyles({
        root: {
            minHeight: 100,
            paddingLeft: "0",
            paddingRight: "0",
            transition: `all .3s var(--cubic-bezier)`,
            "&$expanded": {
                minHeight: 100,
            },
            "@media screen and (min-width: 760px)": {
                paddingLeft: `var(--space-xl)`,
                paddingRight: `var(--space-xl)`,
            },
        },
        expanded: {
            marginTop: "8px !important",
            marginBottom: "0 !important",
            color: `${categoryAccentVar[categorySlug]}`,
        },
    })(MuiExpansionPanelSummary)

    return (
        <>
            <div className="ehi-header--spacer"></div>
            <section className={`${categoryClasses[categorySlug]}`}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div
                            className="col-xl-8 col-lg-9 text-center"
                            style={{
                                opacity: 0,
                                animation:
                                    "scaleDown 1s cubic-bezier(0.215,0.61,0.355,1) forwards",
                            }}
                        >
                            <div className="h4">Frequently Asked Questions</div>
                            <h1 className="display-3">{categoryName}</h1>
                            {/* <form className="mt-5 d-flex flex-column flex-md-row form-group">
                                <input
                                    className="form-control form-control-lg h-100 mb-2 mb-md-0 mr-md-3"
                                    name="help-search"
                                    placeholder="Quick search for a question"
                                    type="search"
                                />
                                <button
                                    className="button-primary"
                                    type="submit"
                                    style={{ minWidth: 140 }}
                                >
                                    Search
                                </button>
                            </form>
                            <div className="d-flex flex-wrap align-items-center">
                                <div className="text-small mb-2 mb-sm-0 mr-2">
                                    Popular search terms:
                                </div>

                                <div className="m-1">
                                    <span className="pill">
                                        How to compare plans?
                                    </span>
                                </div>
                                <div className="m-1">
                                    <span className="pill">
                                        What are short-term plans?
                                    </span>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>

            <section className="pt-2 pt-md-5">
                <div className="container container--grid">
                    <div className="container__row">
                        <div
                            className="wysiwyg"
                            style={{
                                opacity: 0,
                                animation:
                                    "fadeUpSubtle 1s cubic-bezier(0.215,0.61,0.355,1) forwards",
                            }}
                        >
                            {data.map((panel, index) => {
                                return (
                                    <ExpansionPanel
                                        expanded={
                                            panelActive === `panel-${index}`
                                        }
                                        key={index}
                                    >
                                        <ExpansionPanelSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            onClick={() => {
                                                if (
                                                    panelActive ===
                                                    `panel-${index}`
                                                ) {
                                                    setPanelActive("")
                                                } else {
                                                    setPanelActive(
                                                        `panel-${index}`
                                                    )
                                                }
                                            }}
                                        >
                                            <h2 className="pr-md-4">
                                                {panel.title}
                                            </h2>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails>
                                            <div
                                                className="h5 font-weight-normal"
                                                dangerouslySetInnerHTML={{
                                                    __html: panel.body,
                                                }}
                                            />
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </section>
            <DividerHr />
            <div className="d-flex justify-content-center text-center">
                <section style={{ maxWidth: 600 }}>
                    <h2 className="display-4 mb-4 mb-sm-5">
                        Can't find what you were looking for?
                    </h2>
                    <div className="p-2 text-center">
                        <p className="mb-xxxxs lead">
                            Representatives available
                        </p>
                        <h4 className="font-weight-normal">
                            Mon - Fri, 9am - 7pm ET
                        </h4>
                        <a
                            href="tel:+1-855-844-9308"
                            className="h2 invoca-phone-number mt-4"
                        >
                            1(877)731-9560
                        </a>
                    </div>
                </section>
            </div>

            <div className="divider divider-bottom bg-green"></div>
            <CtaCategories />
        </>
    )
}
